import type { ReactElement } from "react";
import { IconProps, SvgIcon } from "./SvgIcon";

interface Props extends IconProps {
  borderColor?: string;
  checkColor?: string;
}

export function CheckCircleIcon({
  borderColor,
  className,
  checkColor,
  color = "currentColor",
  fill = "transparent",
  size,
}: Props): ReactElement {
  return (
    <SvgIcon size={size} className={className}>
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke={borderColor ?? color}
        fill={fill}
        strokeWidth="2"
      />
      <path
        d="M8.23 12.47L9.83 14.73C10.24 15.34 11.05 15.35 11.47 14.74L15.83 8.77"
        stroke={checkColor ?? color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
